import { render, staticRenderFns } from "./lrBox.vue?vue&type=template&id=dfd7464e&scoped=true"
import script from "./lrBox.vue?vue&type=script&lang=js"
export * from "./lrBox.vue?vue&type=script&lang=js"
import style0 from "./lrBox.vue?vue&type=style&index=0&id=dfd7464e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd7464e",
  null
  
)

export default component.exports